import React from 'react';
import clsx from 'clsx';

type Props = {
    statusText: string;
    children?: React.ReactNode;
};

export default class StatusBar extends React.Component<Props> {
    render() {
        const { statusText, children } = this.props;

        return (
            <div id="statusBar" className={clsx(
                "shrink-0 h-6 px-3.5 flex items-center overflow-hidden whitespace-nowrap text-ellipsis border-t",
                "font-['Inter',-apple-system,BlinkMacSystemFont,sans-serif] text-[11px]",
                "bg-white text-slate-500 border-slate-200",
                "dark:bg-surface-dark dark:text-white/60 dark:border-accent/15"
            )}>
                <span className="flex-1">
                    {statusText}
                </span>
                <div className="flex gap-1">
                    {children}
                </div>
            </div>
        );
    }
}
